import request from '@/utils/request'
const root = '/oaBusinessApplication'
export const options = type => request({ url: root + '/options', params: { type } })
export const contracts = keyword => request({ url: root + '/contracts', params: { keyword } })
export const contractDefaults = id => request({ url: root + '/contracts/' + encodeURIComponent(id) })
export const businesses = keyword => request({ url: root + '/businesses', params: { keyword } })
export const businessDefaults = id => request({ url: root + '/businesses/' + encodeURIComponent(id) })
export const relatedTypes = () => request({ url: root + '/related/types' })
export const related = params => request({ url: root + '/related', params })
export const list = params => request({ url: root + '/list', params })
export const detail = id => request({ url: root + '/detail/' + encodeURIComponent(id) })
export const save = data => request({ url: root + '/save', method: 'post', data })
export const submit = data => request({ url: root + '/submit', method: 'post', data })
export const withdraw = data => request({ url: root + '/withdraw', method: 'post', data })
export const completeHandling = data => request({ url: root + '/completeHandling', method: 'post', data })
